import React, { useState, useEffect } from "react";
import "./AddNewSidebar.css";
import {
  Typography,
  TextField,
  Autocomplete,
  CircularProgress
} from '@mui/material';
import axios from "axios";
import PropTypes from "prop-types";
import { API_ENDPOINTS } from './config/api.config';

 
 
function AddNewSidebar({ onClose }) {
 
  const [projectForm, setProjectForm] = useState({
    projectName: "",
    description: "",
    clientName: ""
  });
 
  const [leadForm, setLeadForm] = useState({
    leads: []
  });
 
  const [pmForm, setPmForm] = useState({
    projectManagers: []
  });
 
  const [leadOptions, setLeadOptions] = useState([]);
  const [pmOptions, setPmOptions] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [loadingPMs, setLoadingPMs] = useState(false);
  // 'lead' | 'pm' | null
  const fetchLeads = async () => {
    try {
      setLoadingLeads(true);
 
      const res = await axios.get(API_ENDPOINTS.LEADS_DROPDOWN);
 
      setLeadOptions(res.data?.employees || []);
    } catch (err) {
      console.error("Fetch leads failed:", err);
    } finally {
      setLoadingLeads(false);
    }
  };
  const fetchPMs = async () => {
    try {
      setLoadingPMs(true);
 
      const res = await axios.get(API_ENDPOINTS.PMS_DROPDOWN);
 
      setPmOptions(res.data?.employees || []);
    } catch (err) {
      console.error("Fetch PMs failed:", err);
    } finally {
      setLoadingPMs(false);
    }
  };
 
  useEffect(() => {
    fetchLeads();
    fetchPMs();
  }, []);
 
  const handleProjectChange = (e) => {
    setProjectForm({ ...projectForm, [e.target.name]: e.target.value });
  };
 
  const handleLeadChange = (event, value) => {
    const ids = value.map(v => v.employeeId);
    setLeadForm({ leads: ids });
  };
 
  const handlePMChange = (event, value) => {
    const ids = value.map(v => v.employeeId);
    setPmForm({ projectManagers: ids });
  };
 
  const submitProject = () => {
    console.log("Project submit", projectForm);
    axios.post(API_ENDPOINTS.SUBMIT_PROJECTS, projectForm)
      .then(response => {
        console.log("Project submitted successfully:", response.data);
      })
      .catch(error => {
        console.error("Error submitting project:", error);
      });
  };
 
  const submitLead = () => {
    const payload = {
      employeeIds: leadForm.leads,
      role: "lead"
    };
 
    axios.post(API_ENDPOINTS.SUBMIT_LEAD_PM, payload)
      .then(response => {
        console.log("Lead submitted successfully:", response.data);
 
        // ✅ RESET
        setLeadForm({ leads: [] });
      })
      .catch(error => {
        console.error("Error submitting lead:", error);
      });
  };
 
  const submitPM = () => {
    const payload = {
      employeeIds: pmForm.projectManagers,
      role: "pm"
    };
 
    axios.post(API_ENDPOINTS.SUBMIT_LEAD_PM, payload)
      .then(response => {
        console.log("PM submitted successfully:", response.data);
 
        // ✅ RESET
        setPmForm({ projectManagers: [] });
      })
      .catch(error => {
        console.error("Error submitting PM:", error);
      });
  };
 
  return (
      <div className="addnew">
        <div className="addnew-header">
          <h2>Add New</h2>
          <button
            type="button"
            className="addnew-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
 
        <Typography className="text-bold">Projects</Typography>
 
        <TextField
          fullWidth
          label="Project Name"
          name="projectName"
          value={projectForm.projectName}
          onChange={handleProjectChange}
          margin="normal"
          size="small"
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={projectForm.description}
          onChange={handleProjectChange}
          margin="normal"
          multiline
          rows={3}
          size="small"
 
        />
        <TextField
          fullWidth
          label="Client Name"
          name="clientName"
          value={projectForm.clientName}
          onChange={handleProjectChange}
          margin="normal"
          size="small"
 
        />
        <button
          onClick={submitProject}
          style={{ marginBottom: '20px' }}
          className="btn-submit"
        >
          Add Project
        </button>
 
        <Typography className="mb-15 text-bold">Lead</Typography>
        <Autocomplete
          multiple
          options={leadOptions}
          disableCloseOnSelect
          value={leadOptions.filter(opt =>
            leadForm.leads.includes(opt.employeeId)
          )}
          onChange={handleLeadChange}
          getOptionLabel={(opt) => opt.employeeName || ""}
          loading={loadingLeads}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Leads"
              placeholder="Search lead name..."
              size="small"
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingLeads ? (
                        <CircularProgress size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }
              }}
            />
          )}
        />
        <button
          onClick={submitLead}
          style={{ marginTop: '10px', marginBottom: '20px' }}
          className="btn-submit"
        >
          Add Lead
        </button>
 
        {/* <Divider className="mb-15" /> */}
 
        <Typography className="mb-15 text-bold">Project Manager</Typography>
        <Autocomplete
          multiple
          options={pmOptions}
          disableCloseOnSelect
          value={pmOptions.filter(opt =>
            pmForm.projectManagers.includes(opt.employeeId)
          )}
          onChange={handlePMChange}
          getOptionLabel={(opt) => opt.employeeName || ""}
          loading={loadingPMs}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Project Managers"
              placeholder="Search by name..."
              size="small"
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingPMs ? (
                        <CircularProgress size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }
              }}
            />
          )}
        />
        <button    
          onClick={submitPM}
          style={{ marginTop: '10px', marginBottom: '20px' }}
          className="btn-submit"
        >
          Add PM
        </button>
        {/* <Divider className="mb-15" /> */}
      </div>
  );
}

AddNewSidebar.propTypes = {
  onClose: PropTypes.func.isRequired
};

 
export default AddNewSidebar;